//src/pages/admin/dashboard/tabs/financials/fds/index.jsx

import React, { useEffect, useState } from "react";
import CustomDataGrid from "../../../../../../components/common/CustomDataGrid";
import { fdColumns } from "../../../../../../constants/columns/financialColumns";
import { adminApi } from "../../../../../../services";
import { Link } from "react-router-dom";

export default function FDs() {
  const [fds, setFds] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchFDs = async () => {
    try {
      const res = await adminApi.getAllFDs();
      setFds(res?.data?.data || []);
    } catch (err) {
      console.error(err);
      alert("Failed to fetch FDs");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFDs();
  }, []);

  return (
    <div className="container-fluid">
      <div className="d-flex justify-content-between mb-3">
        <h2>Fixed Deposits</h2>
        <Link to="/admin-dashboard/fds/create">
          <button className="btn btn-primary">+ Create FD</button>
        </Link>
      </div>

      <CustomDataGrid
        rows={fds}
        columns={fdColumns}
        loading={loading}
        getRowId={(row) => row._id}
      />
    </div>
  );
}
